export const autosetupTagColours = {
  primary: ['blue', 'orange', 'red'],
  secondary: ['green', 'maroon', 'skyblue']
}
